import { gql } from '@apollo/client'

export interface CancelOrderLineItems {
  orderId: number
  deleteRosterProfiles: boolean
  orderLineItemIds: [number]
}

export interface Data {
  id: number
}

const Mutation = gql`
  mutation CancelOrderLineItems(
    $orderId: ID!
    $orderLineItemIds: [Int]!
    $deleteRosterProfiles: Boolean!
  ) {
    cancelOrderLineItems(
      orderId: $orderId
      orderLineItemIds: $orderLineItemIds
      deleteRosterProfiles: $deleteRosterProfiles
    ) {
      id
      lineItems {
        id
        canceled
      }
    }
  }
`

export default Mutation
